import { useGetPopularRsvpQuestions } from '@bridebook/web/lib/rsvp/hooks/use-get-popular-rsvp-questions';
import { RsvpQuestion } from '@bridebook/web/lib/rsvp/types';
import { isSameRsvpQuestion } from '@bridebook/web/lib/rsvp/utils/is-same-rsvp-question';
import { useCallback } from 'react';

export const useGetIsPopularRsvpQuestions = () => {
  const popularRsvpQuestions = useGetPopularRsvpQuestions();
  const isPopularRsvpQuestion = useCallback(
    (question: RsvpQuestion) =>
      popularRsvpQuestions.some((popularQuestion) => isSameRsvpQuestion(question, popularQuestion)),
    [popularRsvpQuestions],
  );
  return isPopularRsvpQuestion;
};
